import React from 'react'
import store from '../../../store'
import { ActionType } from '../../../store/error/actions'

type Props = {
  errorStatusCode: number
}

function AppErrorDispatcher(props: Props): JSX.Element {
  store.dispatch({
    type: ActionType.SET_BY_STATUS,
    payload: { statusCode: props.errorStatusCode, message: '' }
  })
  return <></>
}

export default AppErrorDispatcher
